import { Component, ViewEncapsulation, ViewChild, Input, NgModule } from '@angular/core';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/show-more.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';

const _c0 = ["clipTester"];
const _c1 = ["clipContent"];
const _c2 = ["*"];
class ShowMoreComponent {
    constructor() {
        // Check if clipping is even required
        this.clipped = false;
        this._expanded = false;
    }
    /**
     * @return {?}
     */
    ngDoCheck() {
        this.clipped = this.clipTester.nativeElement.offsetHeight < this.clipContent.nativeElement.offsetHeight;
    }
    /**
     * @return {?}
     */
    get expanded() { return this.passedExpanded !== undefined ? this.passedExpanded : this._expanded; }
    // Public methods
    /**
     * @return {?}
     */
    expand() { this._expanded = true; }
    /**
     * @return {?}
     */
    collapse() {
        this._expanded = false;
        // Returns the amount reduced in case the caller wants to reposition the scroll
        return this.clipContent.nativeElement.offsetHeight - this.clipTester.nativeElement.offsetHeight;
    }
    /**
     * @return {?}
     */
    toggle() { this._expanded = !this._expanded; }
}
ShowMoreComponent.ɵfac = function ShowMoreComponent_Factory(t) { return new (t || ShowMoreComponent)(); };
ShowMoreComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ShowMoreComponent, selectors: [["egov-show-more"]], viewQuery: function ShowMoreComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, 7);
        ɵngcc0.ɵɵviewQuery(_c1, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.clipTester = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.clipContent = _t.first);
    } }, inputs: { passedExpanded: ["expanded", "passedExpanded"] }, ngContentSelectors: _c2, decls: 7, vars: 4, consts: [[1, "clip"], ["clip", ""], [1, "show-more-content"], ["clipContent", ""], [1, "clip-tester"], ["clipTester", ""]], template: function ShowMoreComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0, 1)(2, "div", 2, 3);
        ɵngcc0.ɵɵprojection(4);
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelement(5, "div", 4, 5);
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("clipped", ctx.clipped)("expanded", ctx.expanded);
    } }, styles: ["egov-show-more{display:block;position:relative}egov-show-more .clip.clipped:not(.expanded){overflow:hidden;max-height:70vh}egov-show-more .clip.clipped:not(.expanded)::after{content:\"\";position:absolute;left:0;right:0;bottom:0;height:230px;max-height:90%;background:-webkit-gradient(linear,left top,left bottom,from(rgba(255,255,255,0)),to(#fff));background:linear-gradient(to bottom,rgba(255,255,255,0),#fff);pointer-events:none}egov-show-more .clip-tester{position:absolute;left:0;top:0;width:0;visibility:hidden;height:70vh}"], encapsulation: 2 });
ShowMoreComponent.propDecorators = {
    clipTester: [{ type: ViewChild, args: ['clipTester', { static: true },] }],
    clipContent: [{ type: ViewChild, args: ['clipContent', { static: true },] }],
    passedExpanded: [{ type: Input, args: ['expanded',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ShowMoreComponent, [{
        type: Component,
        args: [{ selector: 'egov-show-more', template: "<div #clip class=\"clip\" [class.clipped]=\"clipped\" [class.expanded]=\"expanded\">\n    <div class=\"show-more-content\" #clipContent>\n        <ng-content></ng-content>\n    </div>\n</div>\n<div #clipTester class=\"clip-tester\"></div>\n", encapsulation: ViewEncapsulation.None, styles: ["egov-show-more{display:block;position:relative}egov-show-more .clip.clipped:not(.expanded){overflow:hidden;max-height:70vh}egov-show-more .clip.clipped:not(.expanded)::after{content:\"\";position:absolute;left:0;right:0;bottom:0;height:230px;max-height:90%;background:-webkit-gradient(linear,left top,left bottom,from(rgba(255,255,255,0)),to(#fff));background:linear-gradient(to bottom,rgba(255,255,255,0),#fff);pointer-events:none}egov-show-more .clip-tester{position:absolute;left:0;top:0;width:0;visibility:hidden;height:70vh}"] }]
    }], function () { return []; }, { clipTester: [{
            type: ViewChild,
            args: ['clipTester', { static: true }]
        }], clipContent: [{
            type: ViewChild,
            args: ['clipContent', { static: true }]
        }], passedExpanded: [{
            type: Input,
            args: ['expanded']
        }] }); })();
if (false) {
    /** @type {?} */
    ShowMoreComponent.prototype.clipTester;
    /** @type {?} */
    ShowMoreComponent.prototype.clipContent;
    /** @type {?} */
    ShowMoreComponent.prototype.clipped;
    /** @type {?} */
    ShowMoreComponent.prototype.passedExpanded;
    /**
     * @type {?}
     * @private
     */
    ShowMoreComponent.prototype._expanded;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/show-more.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ShowMoreModule {
}
ShowMoreModule.ɵfac = function ShowMoreModule_Factory(t) { return new (t || ShowMoreModule)(); };
ShowMoreModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: ShowMoreModule });
ShowMoreModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({});
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ShowMoreModule, [{
        type: NgModule,
        args: [{
                declarations: [ShowMoreComponent],
                imports: [],
                exports: [ShowMoreComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(ShowMoreModule, { declarations: [ShowMoreComponent], exports: [ShowMoreComponent] }); })();

/**
 * @fileoverview added by tsickle
 * Generated from: public-api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: egovsolutions-angular-show-more.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { ShowMoreModule, ShowMoreComponent as ɵa };

